export const AGORA_APP_ID = 'e49ba83b5be24340a1864325cf98e5c7' // set your app id here